"use client";
import { Button, Skeleton } from "@mui/material";
import NextLink from "next/link";
import AvatarMenu from "@/app/_components/AvatarMenu";
import { useSession } from "next-auth/react";
import LoginIcon from "./Icons/LoginIcon";

export default function AvatarLogin() {
  const auth = useSession();
  if (auth?.status === "loading") {
    return <Skeleton variant={"rounded"} width={120} height={32} />;
  }
  if (auth?.data) {
    return <AvatarMenu />;
  } else {
    return (
      <Button color="inherit" href="/login" component={NextLink} startIcon={<LoginIcon />}>
        ورود / عضویت
      </Button>
    );
  }
}
